import React from 'react';
import { Pane, Heading, Button, Text } from 'evergreen-ui';
import { CsvImportProvider } from '../context/CsvImportContext';
import CsvImportPage from '../CsvImportPage';

/**
 * Order-specific CSV import page
 *
 * @param {Object} props - Component props
 * @param {Function} props.onClose - Function to call when the import is closed
 */
const OrderImportPage = ({ onClose }) => {
  return (
    <CsvImportProvider>
      <Pane>
        {/* <Pane
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          marginBottom={16}
          borderBottom="1px solid #EDF0F2"
          paddingBottom={16}
        >
          <Heading size={700}>Import Orders from CSV</Heading>
          <Button appearance="minimal" iconBefore="cross" onClick={onClose}>
            Close
          </Button>
        </Pane>

        <Pane marginBottom={24}>
          <Text>
            Import your order data from a CSV file. Follow the steps below to map your CSV columns
            to order fields, validate the data, and import it into your account.
          </Text>
        </Pane> */}

        <CsvImportPage
          entityType="order"
          onComplete={onClose}
          requiredFields={[
            // Keep order_group internal?
            // { name: 'order_group', label: 'Order Group' },
            { name: 'order_number', label: 'Order Number' }, // Might be PO Number?
            { name: 'customer_name', label: 'Customer Name' }, // Changed from email, now required
            { name: 'order_date', label: 'Order Date' }, // Still important
            { name: 'isbn', label: 'Product ISBN' },
            { name: 'quantity', label: 'Quantity' },
            { name: 'retail_price', label: 'Retail Price' }, // Or net_price?
          ]}
          optionalFields={[
            { name: 'customer_email', label: 'Customer Email' },
            { name: 'customer_phone', label: 'Customer Phone' },
            { name: 'shipping_address_str', label: 'Shipping Address' },
            { name: 'net_price', label: 'Net Price' }, // Use if different from retail
            // { name: 'customer_name', label: 'Customer Name' }, // Moved to required
            // { name: 'total_amount', label: 'Total Amount' }, // Calculated automatically
            { name: 'order_status', label: 'Status' }, // Keep optional
            // { name: 'payment_method', label: 'Payment Method' }, // Need PaymentTerm mapping?
            { name: 'payment_term', label: 'Payment Term' },
            // { name: 'shipping_address', label: 'Shipping Address' }, // Replaced by shipping_address_str
            // { name: 'billing_address', label: 'Billing Address' }, // Not currently handled
            { name: 'po_number', label: 'PO Number' },
            { name: 'salesperson', label: 'Salesperson' },
            { name: 'shipping_type', label: 'Shipping Type' },
            { name: 'shipping_cost', label: 'Shipping Cost' },
            { name: 'paid', label: 'Paid (True/False)' },
            { name: 'paid_date', label: 'Paid Date' },
            { name: 'shipped', label: 'Shipped (True/False)' },
            { name: 'ship_date', label: 'Ship Date' },
            { name: 'notes', label: 'Notes' }, // Map to admin_notes?
            // { name: 'products', label: 'Products (JSON)' }, // No longer used
          ]}
        />
      </Pane>
    </CsvImportProvider>
  );
};

export default OrderImportPage;
